import { Route } from '@angular/router';
import { PUBLISHED_PRODUCTS } from './plugin-catalog';

export const appRoutes: Route[] = [
  {
    path: '',
    title: 'Imagise .NET Imaging Plugins',
    loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent),
  },
  ...PUBLISHED_PRODUCTS.map(
    (product): Route => ({
      path: product.slug,
      title: product.seo.title,
      data: { pluginSlug: product.slug },
      loadComponent: () =>
        import('./pages/product-detail/product-detail.component').then(m => m.ProductDetailComponent),
    })
  ),
  {
    path: '**',
    redirectTo: '',
  },
];
